import { Action } from '@ngrx/store';
import {Fleet} from "../models/fleet.model";
import {User} from "../models/user.model";

export enum FleetUserActionTypes {
  SaveFleetUser = '[FleetUser] Save FleetUsers',
  FleetUserSaved = '[FleetUser] FleetUsers saved',
  FleetUserSaveFail = '[FleetUser] FleetUsers save fail'
}

export class SaveFleetUser implements Action {
  readonly type = FleetUserActionTypes.SaveFleetUser;
}

export class FleetUserSaved implements Action {
  readonly type = FleetUserActionTypes.FleetUserSaved;

  constructor(user:User | null) {}
}

export class FleetUserSaveFail implements Action {
  readonly type = FleetUserActionTypes.FleetUserSaveFail;

  constructor(msg:any | null) {}
}


export type FleetUserActions = SaveFleetUser | FleetUserSaved | FleetUserSaveFail;
